import { Theme } from '@mui/material';
import { SxProps } from '@mui/material/styles';

export const getStyles = (theme: Theme): Record<string, SxProps<Theme>> => ({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    gap: { xs: theme.spacing(5), sm: theme.spacing(6) },

    '& .MuiTabs-root': {
      width: '100%',
    },

    '& .MuiTabs-scroller': { outline: 'none', tabIndex: -1 },

    '& .MuiTabs-indicator': {
      height: { xs: '3px', sm: '4px' },
      backgroundColor: theme.palette.surface.positive,
    },

    '& [role="tablist"]': {
      gap: theme.spacing(6),
    },

    '& [role="tab"]': {
      width: { xs: 'min-content', sm: 'fit-content' },
      minWidth: { xs: 'min-content', sm: 'fit-content' },
      gap: theme.spacing(3),
    },
    '& [role="tab"] .MuiTab-icon ': {
      width: { xs: theme.spacing(5), sm: theme.spacing(6) },
      height: { xs: theme.spacing(5), sm: theme.spacing(6) },
    },

    '& [role="tab"][aria-selected="true"]': {
      fontWeight: theme.typography.fontWeightBold,
    },
    '& [role="tab"][aria-selected="false"]': {
      color: theme.palette.secondary.dark,
      opacity: 1,
    },

    '& .MuiTabs-scrollButtons .MuiSvgIcon-root': {
      width: { xs: theme.spacing(5), sm: theme.spacing(6) },
      height: { xs: theme.spacing(5), sm: theme.spacing(6) },
    },
    '& .MuiTabs-scrollButtons.Mui-disabled': {
      opacity: 0.5,
    },
    //remove the scroll buttons if they aren't needed
    '& .MuiTabs-root:has(.MuiTabs-scrollButtons.Mui-disabled:first-of-type + * + * + .MuiTabs-scrollButtons.Mui-disabled) .MuiTabs-scrollButtons.Mui-disabled':
      {
        display: 'none',
      },
  },

  tabScrollWrapper: {
    width: '100%',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },

  tabHeader: { display: 'flex', alignItems: 'center', gap: '8px' },

  chip: {
    backgroundColor: theme.palette.text.primary,
    height: { xs: theme.spacing(5), sm: theme.spacing(6) },
    color: theme.palette.background.default,
    p: '0px !important',
    boxShadow: 'none',
    '& .MuiChip-label': {
      fontSize: { xs: '13px', sm: '16px' },
      px: { xs: '3px', sm: '6px' },
    },
  },

  contentContainer: {
    width: '100%',
    px: { xs: theme.spacing(5), sm: theme.spacing(6) },
  },
});
